module.exports = __webpack_public_path__ + "img/re.11614fc4.svg";